/** Resolved hexes for `var(--planner-swatch-N)` so contrast can be computed. */
const PLANNER_SWATCH_HEX = Object.freeze({
  'var(--planner-swatch-1)': '#6b8cae',
  'var(--planner-swatch-2)': '#88a96b',
  'var(--planner-swatch-3)': '#d4b886',
  'var(--planner-swatch-4)': '#3d4a52',
  'var(--planner-swatch-5)': '#c97a4a',
  'var(--planner-swatch-6)': '#6a8c5a',
  'var(--planner-swatch-7)': '#c9a0c4',
  'var(--planner-swatch-8)': '#e8b54a',
})

function resolveSwatchHex(swatch) {
  if (!swatch || typeof swatch !== 'string') return null
  if (PLANNER_SWATCH_HEX[swatch]) return PLANNER_SWATCH_HEX[swatch]
  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(swatch.trim())) return swatch.trim()
  return null
}

const TEXT_BLACK = '#000'
const TEXT_WHITE = '#fff'

function relLuminance(hex) {
  if (!hex || typeof hex !== 'string') return 1
  const c = hex.replace('#', '')
  if (c.length !== 3 && c.length !== 6) return 1
  const full = c.length === 3 ? c.split('').map((x) => x + x).join('') : c
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(full.substr(i, 2), 16) / 255)
  const f = (v) => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4)
  return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b)
}

function contrastRatio(luminanceA, luminanceB) {
  const lighter = Math.max(luminanceA, luminanceB)
  const darker = Math.min(luminanceA, luminanceB)
  return (lighter + 0.05) / (darker + 0.05)
}

/**
 * Black label text unless white has the higher contrast on this swatch.
 * The painted color is the color that was measured — not a theme token that
 * can be gray or white.
 */
export function textColorForSwatch(swatch) {
  const hex = resolveSwatchHex(swatch)
  if (!hex) return 'var(--text-primary)'
  const background = relLuminance(hex)
  const contrastWhite = contrastRatio(background, relLuminance(TEXT_WHITE))
  const contrastBlack = contrastRatio(background, relLuminance(TEXT_BLACK))
  return contrastWhite > contrastBlack ? TEXT_WHITE : TEXT_BLACK
}
